(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"]) return;
  try {
    
(function(){var a=document.querySelector('[data-cd]');if(!a)return;var t=a.querySelector('[data-cd-t]'),s=+a.dataset.start*1000,e=+a.dataset.end*1000;
function f(ms){var m=Math.max(0,Math.floor(ms/60000)),d=Math.floor(m/1440),h=Math.floor(m%1440/60),mi=m%60;return (d?d+'d ':'')+h+'h '+mi+'m';}
function run(){var n=Date.now();if(n<s){t.innerHTML='OUR BIGGEST SALE EVER STARTS IN <b>'+f(s-n)+'</b>';}else if(n<e){t.innerHTML='11.11 SALE: FLAT 50% OFF · ENDS IN <b>'+f(e-n)+'</b>';}else{t.textContent='Cash on delivery';}}
run();setInterval(run,30000);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["corp-quote"]) return;
  try {
    
(function(){var s=document.querySelector('[data-cq]');if(!s)return;var min=+s.dataset.min||30,n=s.querySelector('[data-cq-n]');
function v(k){return s.querySelector('[name='+k+']:checked');}
function rs(x){return 'Rs '+String(Math.round(x)).replace(/\B(?=(\d{3})+(?!\d))/g,',');}
function show(){var b=v('cq-b'),g=s.querySelector('[data-gal]');if(!b||!g)return;var k=b.value,first=true;
[].forEach.call(s.querySelectorAll('[data-bx]'),function(x){x.hidden=x.dataset.bx!==k;});
[].forEach.call(s.querySelectorAll('[data-th] button'),function(t){if(!t.hidden&&first){t.setAttribute('aria-current','true');first=false;}else t.removeAttribute('aria-current');});
g.scrollLeft=0;[].forEach.call(g.querySelectorAll('video'),function(x){if(x.closest('[hidden]'))x.pause();else{x.preload='auto';var p=x.play();if(p&&p.catch)p.catch(function(){});}});}
function run(){var q=Math.max(min,parseInt(n.value,10)||min),b=v('cq-b'),o=v('cq-o'),p=b?+b.dataset.p:0;s.querySelector('[data-cq-tot]').textContent=rs(p*q);
s.querySelector('[data-cq-wa]').href='https://wa.me/'+s.dataset.wa+'?text='+encodeURIComponent('Hi Date Pop, I would like a corporate quote: '+q+' x '+(b?b.value:'')+(o?' for '+o.value:'')+', with our logo sticker. Please share your bulk price.');}
s.addEventListener('change',function(e){if(e.target.name==='cq-b')show();run();});s.addEventListener('input',run);s.addEventListener('click',function(e){if(e.target.closest('[data-q]'))setTimeout(run,0);});
n.addEventListener('blur',function(){if((parseInt(n.value,10)||0)<min)n.value=min;run();});run();})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["favour-builder"]) return;
  try {
    
(function(){var s=document.querySelector('[data-fb]');if(!s)return;
var LAY={1:[[30,22,0]],2:[[10,24,-8],[50,24,8]],3:[[0,34,-10],[30,8,4],[60,34,10]],4:[[0,40,-10],[22,4,-4],[46,4,6],[64,40,10]],5:[[0,50,-10],[20,16,-4],[42,0,4],[62,16,8],[70,52,12]],6:[[0,52,-12],[18,18,-6],[38,0,0],[58,18,6],[70,54,12],[34,48,0]]};
var RC={'Maroon':[.3,.04,.06],'Red':[1,.1,.14],'Pink':[1,.62,.75],'Orange':[1,.48,.12],'Yellow':[1,.85,.1],'Gold':[.78,.64,.4],'Silver':[.8,.82,.85],'Ivory':[1,.96,.86],'Black':[.12,.12,.12]};
var MIX=['Paan-tastic','Cookies and Cream'],mx=s.querySelector('[data-fb-mx]');
function v(n){var r=s.querySelector('[name='+n+']:checked');return r?r.value:'';}
function rs(x){return 'Rs '+String(Math.round(x)).replace(/\B(?=(\d{3})+(?!\d))/g,',');}
function run(){var n=Math.max(30,parseInt(s.querySelector('[data-fb-n]').value,10)||30),d=+v('fb-d'),ck=[].slice.call(s.querySelectorAll('[name=fb-f]:checked')),all={};
s.querySelectorAll('[name=fb-f]').forEach(function(x){all[x.value]=x;});
var mix=!ck.length,sel=mix?MIX:ck.map(function(x){return x.value;});
if(!mix&&sel.length>d&&sel.length<=6){d=sel.length;var r=s.querySelector('[name=fb-d][value="'+d+'"]');if(r)r.checked=true;}
var td=n*d,up=td<100?10:td<200?5:0,dates=0,pile='',L=LAY[d];
s.querySelectorAll('[name=fb-f]').forEach(function(x){x.parentNode.querySelector('[data-fb-dp]').textContent=rs(+x.dataset.p+up);});
for(var i=0;i<d;i++){var nm=sel[i%sel.length],el=all[nm];dates+=+el.dataset.p+up;pile+='<img src="'+el.dataset.img+'" alt="'+nm+'" style="left:'+L[i][0]+'%;top:'+L[i][1]+'%;--r:'+L[i][2]+'deg">';}
var pl=s.querySelector('[data-fb-pile]');pl.style.setProperty('--dw',d>4?'32%':'40%');pl.innerHTML=pile;
var rib=v('fb-r'),c=RC[rib]||RC.Red,k=1.45;s.querySelector('[data-fb-rn]').textContent=rib;
mx.setAttribute('values',(c[0]*k)+' 0 0 0 0 '+(c[1]*k)+' 0 0 0 0 '+(c[2]*k)+' 0 0 0 0 2.6 -2.6 0 0 -0.12');
var names=[];sel.forEach(function(x){if(names.indexOf(x)<0)names.push(x);});names=names.slice(0,d);
s.querySelector('[data-fb-cap]').textContent=d+(d===1?' date':' dates')+': '+names.join(', ')+(mix?' (our classic mix)':'');
var tag=s.querySelector('[name=fb-g]').checked,pp=dates+50+(tag?30:0);s.querySelector('[data-fb-tg]').hidden=!tag;
var msg=n+' bids in clear bags, '+d+(d===1?' date':' dates')+' each ('+names.join(', ')+'), '+rib.toLowerCase()+' ribbon'+(tag?', with a printed name tag':'');
s.querySelector('[data-fb-pp]').textContent=rs(pp);s.querySelector('[data-fb-tn]').textContent=n;s.querySelector('[data-fb-tot]').textContent=rs(pp*n);
s.querySelector('[data-fb-wa]').href='https://wa.me/'+s.dataset.wa+'?text='+encodeURIComponent('Hi Date Pop, I would like wedding bids: '+msg+'. The estimate shows '+rs(pp)+' per guest, '+rs(pp*n)+' in total.');}
s.addEventListener('change',run);s.addEventListener('input',run);s.addEventListener('click',function(e){if(e.target.closest('[data-q]'))setTimeout(run,0);});
s.querySelector('[data-fb-n]').addEventListener('blur',function(){if((parseInt(this.value,10)||0)<30)this.value=30;run();});run();})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.addEventListener('change',function(e){var s=e.target.closest&&e.target.closest('.card__sel');if(!s)return;var c=s.closest('.card'),i=c&&c.querySelector('[data-ci]'),o=s.options[s.selectedIndex];if(i&&o)i.textContent=o.dataset.i||'';});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-deals"]) return;
  try {
    
(function(){var s=document.querySelector('[data-md]');if(!s)return;
function rs(x){return 'Rs '+String(Math.round(x)).replace(/\B(?=(\d{3})+(?!\d))/g,',');}
var NM={};s.querySelectorAll('[name=md-t]').forEach(function(r){NM[r.value]=r.parentNode.querySelector('b').textContent;});
function run(){var t=s.querySelector('[name=md-t]:checked').value,q=s.querySelector('[name=md-q]:checked');
s.querySelectorAll('[name=md-q]').forEach(function(r){var tot=+r.dataset[t],n=+r.value,l=r.parentNode;l.querySelector('[data-md-tot]').textContent=rs(tot);l.querySelector('[data-md-each]').textContent=rs(tot/n)+' a box';});
var tot=+q.dataset[t],n=+q.value,single=+s.dataset['s'+t]||0,sv=single*n-tot;
s.querySelector('[data-md-save]').textContent=sv>0?'You save '+rs(sv)+' on '+n+' boxes':'';
s.querySelector('[data-md-wa]').href='https://wa.me/'+s.dataset.wa+'?text='+encodeURIComponent('Hi Date Pop, I would like the '+n+' Mini Box deal: '+NM[t]+', '+rs(tot)+' ('+rs(tot/n)+' a box). Our event date is ');}
s.addEventListener('change',run);run();})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-grid"]) return;
  try {
    
document.addEventListener('change',function(e){var s=e.target.closest&&e.target.closest('.card__sel');if(!s)return;var c=s.closest('.card'),o=s.options[s.selectedIndex];if(!c||!o)return;var i=c.querySelector('[data-ci]');if(i)i.textContent=o.dataset.i||'';var im=c.querySelector('.card__im img');if(im&&!im.hasAttribute('data-fix')&&o.dataset.im){im.removeAttribute('srcset');im.src=o.dataset.im;}});

  } catch(e) { console.error(e); }
})();
})();
